import { EmptyBookingPartner } from '~/components/booking-review/booking-partner';
import { AppointmentInformation } from '../components';

export const config = {
  BookingReview: {
    BookingPartner: EmptyBookingPartner,
  },
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
};
